interface BrandedSpinnerProps {
  /** "full" = min-h-screen centered, "section" = py-24 centered, "inline" = no wrapper */
  size?: "full" | "section" | "inline";
  className?: string;
}

const wrapperClass: Record<string, string> = {
  full: "flex min-h-screen items-center justify-center",
  section: "flex items-center justify-center py-24",
  inline: "flex items-center justify-center py-12",
};

const BrandedSpinner = ({ size = "section", className }: BrandedSpinnerProps) => (
  <div className={className ?? wrapperClass[size]}>
    <div className="relative flex items-center justify-center">
      {/* Spinning ring */}
      <div className="absolute h-16 w-16 animate-spin rounded-full border-[3px] border-transparent border-t-primary border-r-primary/40" />
      {/* Pulsing outer glow */}
      <div className="absolute h-16 w-16 animate-pulse rounded-full bg-primary/5" />
      {/* Logo — preloaded SVG from public folder for instant rendering */}
      <img
        src="/vrg-logo.svg"
        alt="Loading"
        className="h-10 w-10 rounded-md object-contain"
        draggable={false}
      />
    </div>
  </div>
);

export default BrandedSpinner;
